__turbopack_context__.v({
  "discount": "RewardsBenefitRow-module__8SZjfa__discount",
  "infoTrigger": "RewardsBenefitRow-module__8SZjfa__infoTrigger",
  "label": "RewardsBenefitRow-module__8SZjfa__label",
  "placeholder": "RewardsBenefitRow-module__8SZjfa__placeholder",
  "popoverBody": "RewardsBenefitRow-module__8SZjfa__popoverBody",
  "row": "RewardsBenefitRow-module__8SZjfa__row",
});
